import { FC } from "react";
import LoadingSpinner from "@app/shared/LoadingSpinner";
import { QESAlert } from "@app/shared/qes-standards/Alert";
import { getGenericErrorMessage } from "@app/shared/utility/getGenericErrorMessage";
import { QESWidget, QESWidgetContent, QESWidgetHeader, QESWidgetTitle } from "@app/shared/widget";
import { useIsolatedGapInstances } from "@app/compliance-connect/regulator/hooks/useIsolatedGapInstances";

const ComplianceConnectIsolatedGapInstancesWidget: FC = () => {
    const { isolatedGapInstances, isolatedGapInstancesError, isLoading: loading } = useIsolatedGapInstances();

    const renderContent = () => {
        if (loading) return <LoadingSpinner />;
        if (isolatedGapInstancesError) return <QESAlert type="danger" persist>{getGenericErrorMessage()}</QESAlert>;
        return (
            <>
                <p className="compliance-connect-stat-widget__description">These gaps are only present for {isolatedGapInstances?.issuerCount ?? 0} issuer(s)</p>
                <p data-testid="compliance-connect-isolated-gap-count" className="compliance-connect-stat-widget__count">
                    {(isolatedGapInstances?.gapCount ?? 0).toLocaleString()}
                    <span data-testid="compliance-connect-isolated-gap-label" className="compliance-connect-stat-widget__label"> Gaps</span>
                </p>
            </>
        );
    };

    return (
        <QESWidget className="compliance-connect-stat-widget">
            <QESWidgetHeader>
                <QESWidgetTitle className="compliance-connect-stat-widget__title">TOTAL ISOLATED GAP INSTANCES</QESWidgetTitle>
            </QESWidgetHeader>
            <QESWidgetContent>
                {renderContent()}
            </QESWidgetContent>
        </QESWidget>
    );
};

export default ComplianceConnectIsolatedGapInstancesWidget;
